import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'importMapFilter' })
export class ImportMappedColumnsFilterPipe implements PipeTransform {

    transform(records: Array<any>, selectedTabIndex: number = 0, useArrayCheck: boolean = false): any {
        if (records && records.length && selectedTabIndex) {
            return records.filter(field => {
                if (useArrayCheck) {
                    if (selectedTabIndex === 1) {
                        return field.moduleFields?.length > 0;
                    } else if (selectedTabIndex === 2) {
                        return !field.moduleFields || field.moduleFields.length === 0;
                    }
                } else {
                    if (selectedTabIndex === 1) {
                        return field.moduleField;
                    } else if (selectedTabIndex === 2) {
                        return !field.moduleField;
                    }
                }
                return true;
            });
        }

        return records;
    }
}
